import { useCallback, useRef, useState } from 'react'
import { useEventNotifications } from '@/lib/hooks/useEventNotifications'
import { EventToast } from './EventToast'

interface EventToastContainerProps {
  spaceId?: string
  enabled?: boolean
}

/**
 * One toast at a time for the Events module ("ao vivo", "começa em breve", reminder). A toast stays on
 * screen until it closes (by itself or by the person); then the next one shows. Each id shows once.
 */
export function EventToastContainer({ spaceId, enabled = true }: EventToastContainerProps) {
  const { notifications, clearNotification } = useEventNotifications({
    spaceId,
    enabled,
    checkInterval: 30000
  })
  const closedRef = useRef(new Set<string>())
  const [, setClosedCount] = useState(0)

  const close = useCallback((id: string) => {
    closedRef.current.add(id)
    setClosedCount((n) => n + 1)
    clearNotification(id)
  }, [clearNotification])

  const current = notifications.find((n) => !closedRef.current.has(n.id))
  if (!enabled || !current) return null

  return (
    <EventToast
      key={current.id}
      id={current.id}
      type={current.type}
      event={current.event}
      onClose={() => close(current.id)}
      autoClose={true}
      autoCloseDelay={8000}
    />
  )
}
